import { render, staticRenderFns } from "./TicoursesAssessment.vue?vue&type=template&id=4489c068"
import script from "./TicoursesAssessment.vue?vue&type=script&lang=js"
export * from "./TicoursesAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports